import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export function usePermissions() {
	return {
		isAccessoryEditor: arePermissionsInUserPermissions([PERMISSIONS.WRITEACCESSORY]),
		isAccessoryReader: arePermissionsInUserPermissions([PERMISSIONS.READACCESSORY]),
		isAdministrator: arePermissionsInUserPermissions([PERMISSIONS.ADMINISTRATE]),
		isBaseIngredientEditor: arePermissionsInUserPermissions([PERMISSIONS.WRITEBASEINGREDIENT]),
		isBaseIngredientReader: arePermissionsInUserPermissions([PERMISSIONS.READBASEINGREDIENT]),
		isIngredientEditor: arePermissionsInUserPermissions([PERMISSIONS.WRITEINGREDIENT]),
		isIngredientReader: arePermissionsInUserPermissions([PERMISSIONS.READINGREDIENT]),
		isMenuEditor: arePermissionsInUserPermissions([PERMISSIONS.WRITEMENU]),
		isMenuPlanEditor: arePermissionsInUserPermissions([PERMISSIONS.WRITEMENUPLAN]),
		isMenuPlanPublisher: arePermissionsInUserPermissions([PERMISSIONS.PUBLISHMENUPLAN]),
		isMenuPlanReader: arePermissionsInUserPermissions([PERMISSIONS.READMENUPLAN]),
		isMenuReader: arePermissionsInUserPermissions([PERMISSIONS.READMENU]),
		isModificationAnalyticsReader: arePermissionsInUserPermissions([
			PERMISSIONS.READMODIFICATIONSANALYTICS,
		]),
		isReader: arePermissionsInUserPermissions([PERMISSIONS.READ]),
		isRecipeEditor: arePermissionsInUserPermissions([PERMISSIONS.WRITERECIPE]),
		isRecipeReader: arePermissionsInUserPermissions([PERMISSIONS.READRECIPE]),
		isStatisticsAnalyticsReader: arePermissionsInUserPermissions([
			PERMISSIONS.READSTATISTICSANALYTICS,
		]),
		isStatusAnalyticsReader: arePermissionsInUserPermissions([
			PERMISSIONS.READRECIPESTATUSANALYTICS,
		]),
		isUnitEditor: arePermissionsInUserPermissions([PERMISSIONS.WRITEUNIT]),
	};
}
